import React, { Component, Fragment } from 'react';
import { Modal, Button} from 'react-bootstrap';

class Example extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false
    }
  }

  
  render() {
    const { show } = this.props;
    const func = this.props.enviarInfo;
    const close = this.props.handleClose;
    const mensajeConfirm = this.props.mensaje;
    //const func = this.props.irHome;
    //const { data } = this.props;
    ////console.log(data);
    return (
      <Fragment>
        <Modal
          show={show}
          onHide={close}
          backdrop="static"
          keyboard={false}
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>¡ATENCIÓN! </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {mensajeConfirm}
              </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={func}>Aceptar</Button>
            <Button variant="secondary" onClick={close}>Cancelar</Button>
          </Modal.Footer>
        </Modal>
      </Fragment>
    );
  }
}

export default Example;


// WEBPACK FOOTER //
// ./src/components/subcomponent/modalConfirm.jsx